export const LIVESTREAMING_PERIOD_LABELS = {
  day: 'Current Day',
  month: 'Current Month',
  year: 'Current Year',
  prev_year: 'Previous Year',
};

export const LIVESTREAMING_PERIOD_OPTIONS = ['day', 'month', 'year', 'prev_year'];
